/*eslint-disable*/
import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SketchPicker } from 'react-color';
import ColorPicker from 'react-best-gradient-color-picker';
import {
  EditTemplateIcon,
  DeleteTemplateIcon,
  PlusIcon,
  Accordion,
} from '../../../shared/component/svgIcon';
import SelectBoxNew from '../../../shared/component/form/SelectBoxNew';
import { updateCurrentTemplate } from '../../../redux/slices/TemplateSlice';
import templates from '../../../utils/api/templates';
import { setErrorNotification } from '../../../redux/slices/NotificationSlice';

function StyleDisplayEditor({ setNewData }) {
  const { t } = useTranslation();
  let templateData = useSelector((state) => state?.currentTemplate?.templateContent);
  templateData = Object.keys(templateData)?.length
    ? templateData : JSON.parse(sessionStorage.getItem('templateEditData'));

  let templateDefaultData = useSelector((state) => state?.currentTemplate?.defaultTemplate);
  templateDefaultData = Object.keys(templateDefaultData)?.length
    ? templateDefaultData : JSON.parse(sessionStorage.getItem('currentTemplate'));
  console.log(templateData?.template_images);
  // const [imageRefs] = useState(templateData?.template_images?.map(() => createRef()));
  const [imageRefs, setImageRefs] = useState(() => (templateData?.template_images || []).map(() => createRef()));
  useEffect(() => {
    if (templateData?.template_images?.length) {
      setImageRefs(templateData.template_images.map(() => createRef()));
    }
  }, [templateData]);
  console.log(imageRefs);
  const [openIndex, setOpenIndex] = useState(null);
  const dispatch = useDispatch();
  const styles = templateData?.styles?.column;
  const images = templateData?.template_images;
  const colorData = templateData?.styles?.details;
  const gradientBackground = templateData?.styles?.backgroundColor;
  const solidBackground = templateData?.styles?.background;
  const [gradientColor, setGradientColor] = useState(gradientBackground || templateData?.styles?.backgroundColor);
  const [nonGradientColor, setNonGradientColor] = useState(solidBackground || templateData?.styles?.background);
  const fontStyles = [
    'Lucida Console',
    'Arial',
    'Helvetica',
    'Times New Roman',
    'Courier New',
    'Verdana',
    'Georgia',
    'Palatino',
    'Garamond',
    'Bookman',
    'Comic Sans MS',
    'sans-serif',
    'Trebuchet MS',
    'Arial Black',
    'Impact',
    'Arial Rounded MT Bold',
    'Marker Felt',
    'Inter',
    'Poppins',
    'Alata',
    'Urbanist',
    'Great vibes',
  ];
  const [openColorPicker, setOpenColorPicker] = useState(false);
  const [Picker, setPicker] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const handleColorClick = (index) => {
    setOpenColorPicker(true);
    setSelectedIndex(index);
  };
  const handleColorChange = (color) => {
    setOpenColorPicker(false);
    const styleData = JSON.parse(JSON.stringify(templateData));
    const colorUpdate = styleData?.styles?.details;
    colorUpdate[selectedIndex].color = color?.hex;
    setNewData([styleData]);
    dispatch(updateCurrentTemplate(styleData));
  };
  const handleFontFamily = (selectedOption, index) => {
    const styleData = JSON.parse(JSON.stringify(templateData));
    const fontFamilyUpdate = styleData?.styles?.details;
    fontFamilyUpdate[index].fontFamily = selectedOption?.label || '';

    setNewData([styleData]);

    setTimeout(() => {
      dispatch(updateCurrentTemplate(styleData));
    }, 0);
  };
  // const handleFontSize = (e, index) => {
  //   const styleData = JSON.parse(JSON.stringify(templateData));
  //   if (e.target.value !== 'default') {
  //     const fontFamilyUpdate = styleData?.styles?.details;
  //     fontFamilyUpdate[index].fontSize = e.target.value;
  //     setNewData([styleData]);
  //     dispatch(updateCurrentTemplate(styleData));
  //   } else {
  //     const fontFamilyUpdate = styleData?.styles?.details;
  //     fontFamilyUpdate[index].fontSize = templateDefaultData?.styles?.details?.[index]?.fontSize;
  //     setNewData([styleData]);
  //     dispatch(updateCurrentTemplate(styleData));
  //   }
  // };
  const handleFontSize = (selectedOption, index) => {
    const styleData = JSON.parse(JSON.stringify(templateData));
    const fontSizeValue = selectedOption?.label === 'default'
      ? templateDefaultData?.styles?.details?.[index]?.fontSize
      : selectedOption?.label;

    styleData.styles.details[index].fontSize = fontSizeValue;
    setNewData([styleData]);
    setTimeout(() => {
      dispatch(updateCurrentTemplate(styleData));
    }, 0);
  };
  const handleChangeBackgroundImage = (e, index) => {
    e.preventDefault();
    console.log(imageRefs);
    imageRefs?.[index]?.current?.click();
  };
  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    const request = {
      'background-image': file,
    };
    if (file) {
      const isFromParent = sessionStorage.getItem('isFromParent') === 'true';
      const addFn = isFromParent
        ? templates.updateTemplateImageInCms
        : templates.updateTemplateImage;
      addFn(request).then((res) => {
        const newData = JSON.parse(JSON.stringify(templateData));
        newData.template_images[index].image = res?.data?.background_image;
        dispatch(updateCurrentTemplate(newData));
        setNewData([newData]);
        setShowAdd(false);
      })
        .catch((error) => dispatch(setErrorNotification(error?.response?.data)));
      e.target.value = '';
    }
  };
  const removeBackgroundImage = (index) => {
    const newData = JSON.parse(JSON.stringify(templateData));
    newData.template_images[index].image = null;
    dispatch(updateCurrentTemplate(newData));
    setNewData([newData]);
    setShowAdd(true);
  };
  const handleBgColorClick = () => {
    setPicker(true);
  };
  const handleBlur = () => {
    setPicker(false);
    const newData = JSON.parse(JSON.stringify(templateData));
    newData.styles.backgroundColor = gradientColor;
    dispatch(updateCurrentTemplate(newData));
    setNewData([newData]);
  };
  const handleBlur2 = () => {
    setOpenColorPicker(false);
  };
  const handleBackgroundChange = (color) => {
    setNonGradientColor(color?.hex);
    setPicker(false);
    const newData = JSON.parse(JSON.stringify(templateData));
    newData.styles.background = color?.hex;
    dispatch(updateCurrentTemplate(newData));
    setNewData([newData]);
  };
  // const handleMultipleFontSize = (e, index, value) => {
  //   const styleData = JSON.parse(JSON.stringify(templateData));
  //   if (e.target.value !== 'default') {
  //     const fontFamilyUpdate = styleData?.styles?.details;
  //     const splittedFonts = fontFamilyUpdate?.[index]?.fontSize?.split(',');
  //     splittedFonts[value] = e.target.value;
  //     fontFamilyUpdate[index].fontSize = `${splittedFonts.join(',')}`;
  //     setNewData([styleData]);
  //     dispatch(updateCurrentTemplate(styleData));
  //   } else {
  //     const fontFamilyUpdate = styleData?.styles?.details;
  //     fontFamilyUpdate[index].fontSize = templateDefaultData?.styles?.details?.[index]?.fontSize;
  //     setNewData([styleData]);
  //     dispatch(updateCurrentTemplate(styleData));
  //   }
  // };
  const handleMultipleFontSize = (selectedOption, index, value) => {
    const styleData = JSON.parse(JSON.stringify(templateData));
    const fontFamilyUpdate = styleData?.styles?.details;

    if (selectedOption?.label !== 'default') {
      const splittedFonts = fontFamilyUpdate?.[index]?.fontSize?.split(',') || [];
      splittedFonts[value] = selectedOption?.label;
      fontFamilyUpdate[index].fontSize = splittedFonts.join(',');
    } else {
      fontFamilyUpdate[index].fontSize = templateDefaultData?.styles?.details?.[index]?.fontSize;
    }

    setNewData([styleData]);
    setTimeout(() => {
      dispatch(updateCurrentTemplate(styleData));
    }, 0);
  };

  // const handleMultipleFontFamily = (e, index, value) => {
  //   const styleData = JSON.parse(JSON.stringify(templateData));
  //   const fontFamilyUpdate = styleData?.styles?.details;
  //   const splittedStyle = fontFamilyUpdate?.[index]?.fontFamily?.split(',');
  //   splittedStyle[value] = e.target.value;
  //   fontFamilyUpdate[index].fontFamily = `${splittedStyle.join(',')}`;
  //   setNewData([styleData]);
  //   dispatch(updateCurrentTemplate(styleData));
  // };
  const handleMultipleFontFamily = (selectedOption, index, value) => {
    const styleData = JSON.parse(JSON.stringify(templateData));
    const fontFamilyUpdate = styleData?.styles?.details;
    // Split current fontFamily into an array
    const splittedStyle = fontFamilyUpdate?.[index]?.fontFamily?.split(',') || [];
    // Update the selected font at the given index
    splittedStyle[value] = selectedOption?.label || '';
    // Rejoin array back into a string
    fontFamilyUpdate[index].fontFamily = splittedStyle.join(',');
    setNewData([styleData]);
    setTimeout(() => {
      dispatch(updateCurrentTemplate(styleData));
    }, 0);
  };
  const handleBack = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle behavior
  };
  useEffect(() => {
    if (templateData?.styles) {
      if (templateData.styles.backgroundColor) {
        setGradientColor(templateData.styles.backgroundColor);
      }
      if (templateData.styles.background) {
        setNonGradientColor(templateData.styles.background);
      }
    }
  }, [templateData]);
  return (
    <div className="template-style-display-editor">
      <div className="template-wrapper">
        <p className="header">{t('Template Preview')}</p>
        {(templateData?.signedUrl || templateData?.template_image_url)
          && (
            <div className="image" style={{ marginTop: '10px' }}>
              <img
                style={{ width: '90%' }}
                src={templateData?.signedUrl || templateData?.template_image_url}
                alt="template_image"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            </div>
          )}
        <hr style={{ border: '0.75px solid #D0D5DD', width: '100%', marginLeft: '-9px' }} />
        {styles?.map((data, index) => ( // Added 'index' for unique key
          <div
            className="container"
            style={{ width: colorData?.[index]?.fontFamily?.split(',').length === 2 ? '90%' : '' }}
          >
            <div className="element">
              <p
                className="title"
                style={{ width: colorData?.[index]?.fontFamily?.split(',').length === 2 ? '' : '' }}
              >
                {data?.title}
                <div
                  className="backIcon"
                  style={{
                    paddingLeft: '70px',
                    transform: openIndex === index ? 'scaleY(-1)' : 'scaleY(1)',
                    transition: 'transform 0.3s ease',
                  }}
                  onClick={() => handleBack(index)}
                  role="none"
                >
                  <Accordion />
                </div>
              </p>
              {openIndex === index && (
                <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {colorData?.[index]?.fontFamily?.split(',').length === 1
                    && (
                      <div>
                        {/* <p className="sub-title">
                          {t('Font Style')}
                        </p> */}
                        {/* <select
                          className="selectBox"
                          value={colorData?.[index]?.fontFamily}
                          onChange={(e) => handleFontFamily(e, index)}
                        >
                          {fontStyles.map((font) => (
                            <option
                              style={{ fontFamily: font }}
                              key={font}
                              value={font}
                            >
                              {font}
                            </option>
                          ))}
                        </select> */}
                        <SelectBoxNew
                          name={`fontFamily-${index}`}
                          label="Font Style"
                          placeholder="Select a font"
                          value={colorData?.[index]?.fontFamily || ''}
                          lists={fontStyles.map((font) => ({ id: font, label: font }))}
                          onchange={(name, selectedOption) => handleFontFamily(selectedOption, index)}
                          required={false}
                        />
                      </div>
                    )}
                  {console.log(colorData)}
                  {colorData?.[index]?.fontFamily?.split(',').length > 1
                    && colorData?.[index]?.fontFamily?.split(',').map((fontStyle, value) => (
                      <div>
                        <p className="sub-title">
                          {t('Font Style')}
                        </p>
                        <select
                          className="selectBox"
                          value={fontStyle}
                          onChange={(e) => handleMultipleFontFamily(e, index, value)}
                        >
                          {fontStyles.map((font) => (
                            <option
                              style={{ fontFamily: font }}
                              key={font}
                              value={font}
                            >
                              {font}
                            </option>
                          ))}
                        </select>
                        <SelectBoxNew
                          name={`fontFamily-${index}-${value}`}
                          label="Font Style"
                          placeholder="Select a font"
                          value={fontStyle}
                          lists={fontStyles.map((font) => ({ id: font, label: font }))}
                          onchange={(name, selectedOption) => handleMultipleFontFamily(selectedOption, index, value)}
                          required={false}
                        />
                      </div>
                    ))}
                  {/* <div className="font-size-color-container" style={{ display: 'flex', alignItems: 'center' }}>
                    {colorData?.[index]?.fontSize?.split(',').length === 1
                      && (
                        <div>
                          <p className="sub-title">
                            {t('Font Size')}
                          </p>
                          <select
                            id="fontSizeSelector"
                            className="selectBox"
                            value={colorData?.[index]?.fontSize}
                            onChange={(e) => handleFontSize(e, index)}
                          >
                            <option value="default">default</option>
                            <option value="20px">20px</option>
                            <option value="30px">30px</option>
                            <option value="40px">40px</option>
                            <option value="45px">45px</option>
                          </select>
                          <SelectBoxNew
                            name={`fontSize-${index}`}
                            label="Font Size"
                            id="fontSizeSelector"
                            placeholder="Select font size"
                            value={colorData?.[index]?.fontSize || 'default'}
                            lists={[
                              { id: 'default', label: 'default' },
                              { id: '20px', label: '20px' },
                              { id: '30px', label: '30px' },
                              { id: '40px', label: '40px' },
                              { id: '45px', label: '45px' },
                            ]}
                            onchange={(name, selectedOption) => handleFontSize(selectedOption, index)}
                            required={false}
                          />
                        </div>
                      )}
                    <div>
                      {
                        colorData?.[index]?.fontSize?.split(',').length > 1
                        && colorData?.[index]?.fontSize?.split(',').map((fontSize, value) => (
                          <div>
                            <p className="sub-title">
                              {t('Font Size')}
                            </p>
                            <select
                              id="fontSizeSelector"
                              className="selectBox"
                              value={fontSize}
                              onChange={(e) => handleMultipleFontSize(e, index, value)}
                            >
                              <option value="default">default</option>
                              <option value="20px">20px</option>
                              <option value="30px">30px</option>
                              <option value="40px">40px</option>
                              <option value="45px">45px</option>
                            </select>
                            <SelectBoxNew
                              name={`fontSize-${index}-${value}`}
                              label="Font Size"
                              id="fontSizeSelector"
                              placeholder="Select font size"
                              value={fontSize || 'default'}
                              lists={[
                                { id: 'default', label: 'default' },
                                { id: '20px', label: '20px' },
                                { id: '30px', label: '30px' },
                                { id: '40px', label: '40px' },
                                { id: '45px', label: '45px' },
                              ]}
                              onchange={(name, selectedOption) => handleMultipleFontSize(selectedOption, index, value)}
                              required={false}
                            />
                          </div>
                        ))
                      }
                    </div>
                    <div
                      className="colorBox"
                      style={{
                        backgroundColor: colorData?.[index]?.color,
                      }}
                      role="none"
                      onClick={() => handleColorClick(index)}
                    />
                    {openColorPicker && (
                      <div className="picker">
                        <SketchPicker color={colorData?.[index]?.color} onChange={handleColorChange} />
                        <p className="closeButton" onClick={handleBlur2} role="none">close</p>
                      </div>
                    )}

                  </div> */}
                </div>
              )}
            </div>
          </div>
        ))}
        {
          (gradientBackground || solidBackground)
          && (
            <div className="bgContainer">
              <div style={{
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '90%',
              }}
              >
                <p className="bgTitle">Background color</p>
                <div
                  className="backIcon"
                  style={{
                    transform: openIndex === -1 ? 'scaleY(-1)' : 'scaleY(1)',
                    transition: 'transform 0.3s ease',
                  }}
                  onClick={() => handleBack(-1)}
                  role="none"
                >
                  <Accordion />
                </div>
              </div>
              {openIndex === -1 && (
                <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <p
                    className="sub-title"
                    style={{
                      color: '#475367',
                      fontSize: '10px',
                      fontWeight: '500',
                      padding: '0px 5px 0px 5px',
                    }}
                  >
                    {t('BG Color')}
                  </p>
                  <div
                    className="bgColorBox"
                    style={{
                      background: gradientBackground ? gradientColor : nonGradientColor,
                    }}
                    role="none"
                    onClick={() => handleBgColorClick()}
                  />
                  {Picker
                    && (
                      <div className="bgPicker">
                        {gradientBackground
                          && (
                            <ColorPicker
                              value={gradientColor || gradientBackground}
                              width={240}
                              height={100}
                              onChange={setGradientColor}
                            />
                          )}
                        {solidBackground
                          && (
                            <SketchPicker
                              color={nonGradientColor || solidBackground || '#F04E5B'}
                              onChange={handleBackgroundChange}
                            />
                          )}
                        <p className="closeButton" onClick={handleBlur} role="none">close</p>
                      </div>
                    )}
                </div>
              )}
            </div>
          )
        }
        <hr style={{ border: '0.75px solid #D0D5DD', width: '100%', marginLeft: '-9px' }} />
        {images?.length > 0 && (
          <div className="logoContainer">
            <div
              className="logoHeader"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                width: '90%',
                justifyContent: 'space-between',
              }}
            >
              <p className="header">{t('Logo')}</p>
              <div
                className="backIcon"
                style={{
                  paddingLeft: '56px',
                  transform: openIndex === -2 ? 'scaleY(-1)' : 'scaleY(1)',
                  transition: 'transform 0.3s ease',
                }}
                onClick={() => handleBack(-2)}
                role="none"
              >
                <Accordion />
              </div>
            </div>

            {openIndex === -2 && (
              <div className="toggle" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {images.map((data, imgIndex) => (
                  <div className="imageContainer">
                    <div className="imageBox">
                      {!showAdd && <img src={data?.image} alt="logo" />}
                    </div>
                    <div className="icon">
                      <input
                        type="file"
                        ref={imageRefs?.[imgIndex]}
                        accept="image/*"
                        id={`fileInput-${imgIndex}`}
                        onChange={(e) => handleFileChange(e, imgIndex)}
                        style={{ display: 'none' }}
                      />
                      {showAdd ? (
                        <div onClick={(e) => handleChangeBackgroundImage(e, imgIndex)} role="none">
                          <PlusIcon />
                        </div>
                      ) : (
                        <div onClick={(e) => handleChangeBackgroundImage(e, imgIndex)} role="none">
                          <EditTemplateIcon />
                        </div>
                      )}
                    </div>
                    {!showAdd && (
                      <div className="icon-edit" role="none" onClick={() => removeBackgroundImage(imgIndex)}>
                        <DeleteTemplateIcon />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
StyleDisplayEditor.propTypes = {
  setNewData: PropTypes.node.isRequired,
};
export default StyleDisplayEditor;
